
import Button from '../../../components/base/Button';

export default function ServicesSection() {
  const services = [
    {
      title: 'Massage Suédois',
      duration: '60-90 min',
      price: 'À partir de 80€',
      description: 'Massage relaxant aux mouvements longs et fluides pour détendre les muscles et améliorer la circulation.',
      benefits: ['Relaxation profonde', 'Amélioration circulation', 'Réduction stress'],
      image: 'https://public.readdy.ai/ai/img_res/5728141ab466d4f2868e389c9839bdff.jpg'
    },
    {
      title: 'Massage Deep Tissue',
      duration: '60-75 min',
      price: 'À partir de 90€',
      description: 'Massage thérapeutique en profondeur pour traiter les tensions musculaires chroniques et les nœuds.',
      benefits: ['Soulagement douleurs', 'Mobilité améliorée', 'Récupération sportive'],
      image: 'https://readdy.ai/api/search-image?query=Deep%20tissue%20massage%20therapy%20session%2C%20therapeutic%20pressure%20massage%2C%20muscle%20tension%20relief%2C%20professional%20spa%20treatment%2C%20healing%20massage%2C%20wellness%20therapy%2C%20tropical%20spa%20environment%2C%20therapeutic%20care%2C%20muscle%20recovery&width=400&height=300&seq=deep-tissue-massage&orientation=landscape'
    },
    {
      title: 'Massage aux Pierres Chaudes',
      duration: '75-90 min',
      price: 'À partir de 110€',
      description: 'Massage relaxant utilisant des pierres volcaniques chaudes pour une détente maximale.',
      benefits: ['Détente extrême', 'Chaleur thérapeutique', 'Équilibre énergétique'],
      image: 'https://readdy.ai/api/search-image?query=Hot%20stone%20massage%20therapy%20with%20volcanic%20stones%2C%20spa%20treatment%2C%20relaxation%20therapy%2C%20warm%20stones%20on%20back%2C%20therapeutic%20heat%20treatment%2C%20luxury%20spa%2C%20wellness%20center%2C%20peaceful%20atmosphere%2C%20tropical%20spa%20setting&width=400&height=300&seq=hot-stone-massage&orientation=landscape'
    },
    {
      title: 'Réflexologie Plantaire',
      duration: '45-60 min',
      price: 'À partir de 65€',
      description: 'Stimulation des points réflexes des pieds pour harmoniser l\'ensemble du corps.',
      benefits: ['Équilibre général', 'Stimulation organes', 'Relaxation profonde'],
      image: 'https://readdy.ai/api/search-image?query=Foot%20reflexology%20massage%20therapy%2C%20pressure%20point%20massage%20on%20feet%2C%20therapeutic%20foot%20treatment%2C%20wellness%20spa%2C%20healing%20touch%2C%20professional%20reflexology%2C%20tropical%20spa%20setting%2C%20relaxation%20therapy%2C%20holistic%20healing&width=400&height=300&seq=reflexology-massage&orientation=landscape'
    },
    {
      title: 'Aromathérapie',
      duration: '60-75 min',
      price: 'À partir de 85€',
      description: 'Massage aux huiles essentielles locales pour une expérience sensorielle unique.',
      benefits: ['Bien-être mental', 'Huiles naturelles', 'Expérience sensorielle'],
      image: 'https://readdy.ai/api/search-image?query=Aromatherapy%20massage%20with%20essential%20oils%2C%20natural%20spa%20oils%2C%20therapeutic%20massage%2C%20wellness%20treatment%2C%20essential%20oil%20bottles%2C%20relaxing%20spa%20atmosphere%2C%20tropical%20plants%2C%20natural%20healing%2C%20holistic%20therapy&width=400&height=300&seq=aromatherapy-massage&orientation=landscape'
    },
    {
      title: 'Massage à Domicile',
      duration: '60-90 min',
      price: 'À partir de 120€',
      description: 'Tous nos services disponibles dans le confort de votre domicile en Guadeloupe.',
      benefits: ['Confort domicile', 'Pas de déplacement', 'Intimité préservée'],
      image: 'https://readdy.ai/api/search-image?query=Mobile%20massage%20therapy%20at%20home%2C%20portable%20massage%20table%2C%20home%20spa%20service%2C%20comfortable%20home%20environment%2C%20professional%20massage%20therapist%2C%20relaxation%20at%20home%2C%20wellness%20service%2C%20tropical%20home%20setting&width=400&height=300&seq=home-massage&orientation=landscape'
    }
  ];

  const scrollToReservation = () => {
    const element = document.getElementById('reservation');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="services" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
            Nos <strong>Services de Massage</strong> en <strong>Guadeloupe</strong>
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed">
            Découvrez notre gamme complète de <strong>massages thérapeutiques</strong> et 
            <strong>soins de bien-être</strong> adaptés à vos besoins spécifiques.
          </p>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {services.map((service, index) => (
            <article key={index} className="bg-white rounded-xl shadow-lg overflow-hidden hover:shadow-xl transition-all duration-300 hover:-translate-y-2">
              <div className="relative">
                <img 
                  src={service.image}
                  alt={`${service.title} - Service de massage en Guadeloupe`}
                  title={`${service.title} - Zen Wellness Guadeloupe`}
                  className="w-full h-48 object-cover object-top"
                />
                <div className="absolute top-4 right-4 bg-purple-400 text-white px-3 py-1 rounded-full text-sm font-medium">
                  {service.duration}
                </div>
              </div>
              
              <div className="p-6">
                <h3 className="text-xl font-bold text-gray-900 mb-2">{service.title}</h3>
                <p className="text-gray-600 mb-4 leading-relaxed">{service.description}</p>
                
                <div className="mb-4">
                  <h4 className="font-semibold text-gray-900 mb-2">Bienfaits :</h4>
                  <div className="flex flex-wrap gap-2">
                    {service.benefits.map((benefit, idx) => (
                      <span 
                        key={idx}
                        className="bg-purple-100 text-purple-800 px-3 py-1 rounded-full text-sm"
                      >
                        {benefit}
                      </span>
                    ))}
                  </div>
                </div>
                
                <div className="flex items-center justify-between">
                  <span className="text-2xl font-bold text-purple-600">{service.price}</span>
                  <Button 
                    size="sm"
                    onClick={scrollToReservation}
                  >
                    Réserver
                  </Button>
                </div>
              </div>
            </article>
          ))}
        </div>
        
        <div className="mt-16 text-center">
          <div className="bg-gradient-to-r from-purple-400 to-purple-600 rounded-2xl p-8 md:p-12 text-white">
            <h3 className="text-3xl font-bold mb-4">
              Forfaits Personnalisés Disponibles
            </h3>
            <p className="text-xl mb-8 opacity-90">
              Combinez plusieurs services pour une expérience de bien-être complète. 
              Forfaits couples, forfaits détox, programmes de relaxation sur mesure.
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <Button 
                variant="secondary"
                size="lg"
                onClick={scrollToReservation}
              >
                <i className="ri-gift-line mr-2"></i>
                Découvrir les Forfaits
              </Button>
              <Button 
                variant="outline"
                size="lg"
                onClick={() => document.getElementById('contact')?.scrollIntoView({ behavior: 'smooth' })}
                className="bg-white/10 backdrop-blur-sm border-white text-white hover:bg-white hover:text-gray-900"
              >
                <i className="ri-phone-line mr-2"></i>
                Conseil Personnalisé
              </Button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
